import React from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isEmptyOrBlankString } from '@philips-internal/oswald-ui-utils';
function FormHeader(props) {
    return (React.createElement("div", { className: "c-form__header" },
        !isEmptyOrBlankString(props.title) ? (React.createElement("span", { className: "c-form__title" }, MessageService.translate(props.title ?? ''))) : null,
        props.children));
}
export { FormHeader, };
//# sourceMappingURL=form-header.js.map